import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/movie" },
  { label: "电视剧", to: "/tv" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : "/search");
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-4 py-2 rounded-md text-sm font-medium transition-colors ${
      isActive
        ? "text-primary-700 bg-primary-100"
        : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
              91视频<span className="text-accent-600">免费看</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={handleSearch} className="hidden md:flex items-center ml-auto">
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="text"
                name="q"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索电影、电视剧"
                className="w-56 lg:w-72 pl-10 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="ml-2 px-4 py-2 rounded-full text-sm font-medium bg-accent-500 text-white hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
          <nav className="flex flex-col gap-1 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium ${
                    isActive ? "text-primary-700 bg-primary-100" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <form onSubmit={handleSearch} className="flex items-center gap-2">
            <div className="relative flex-1">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="text"
                name="q"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索电影、电视剧"
                className="w-full pl-10 pr-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400"
              />
            </div>
            <button
              type="submit"
              className="px-4 py-2.5 rounded-full text-sm font-medium bg-accent-500 text-white hover:bg-accent-600 whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
        </div>
      )}
    </header>
  );
}